import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Footer from "../Footer";
import MPLocationMap from "../MPLocationMap";
import { UAE } from "../../mock";

export const Connect = () => (
  <section className="mp-dark" data-testid="home-connect">
    <div className="max-w-[1600px] mx-auto px-6 md:px-10 py-24 md:py-36">
      <div className="grid md:grid-cols-2 gap-6 md:gap-8" data-reveal>
        {UAE.locations.map((loc) => (
          <div key={loc.city} className="border border-[rgba(236,231,219,0.16)]">
            <MPLocationMap city={loc.city} region={loc.region} variant={loc.variant} />
          </div>
        ))}
      </div>

      <div className="mt-16 flex flex-col md:flex-row md:items-end justify-between gap-8" data-reveal>
        <div className="max-w-3xl">
          <h2 className="font-display font-light text-[28px] md:text-[44px] leading-[1.0] tracking-tight text-[#ece7db]">{UAE.connectTitle}</h2>
          <p className="font-display text-[#c9a15f] text-[22px] md:text-[26px] mt-6">{UAE.connectSub}</p>
        </div>
        <Link
          to="/inquiries"
          data-testid="connect-inquiry-link"
          className="inline-flex items-center gap-2 border border-[rgba(236,231,219,0.35)] px-8 py-4 font-label text-[11px] text-[#ece7db] hover:bg-[#ece7db] hover:text-[#1c1a16] transition-colors duration-300 w-max"
        >
          Start an Inquiry <ArrowUpRight className="w-3.5 h-3.5" strokeWidth={1.5} />
        </Link>
      </div>
    </div>
    <Footer theme="dark" />
  </section>
);
